import Tower from './Tower';
import Generic from './Generic';

const templates = {
    Tower,
    Grid: Generic,
    List: Generic
};

export default templates;


